import { Injectable } from '@angular/core';
import { SubscriberService } from '../manager/subscriber.service';

@Injectable({
  providedIn: 'root',
})
export class BarcodeLookupService {
  private map = new Map<string, string>();

  constructor(private sub: SubscriberService) {
    this.sub.productList.subscribe(products => {
      this.map.clear();
      for (const p of products) {
        for (const entry of p.barcodes ?? []) {
          if (entry.barcode) this.map.set(entry.barcode, p.model);
        }
      }
    });
  }

  lookup(ean: string): string | null {
    return this.map.get(ean) ?? null;
  }
}
